import { create } from 'zustand';

type AudioState = {
  isMuted: boolean;
  toggleMute: () => void;
};

const useAudioStore = create<AudioState>((set) => ({
  isMuted: true,
  toggleMute: () => set((state) => ({ isMuted: !state.isMuted }))
}));

export default useAudioStore;
